import PolicyLayout, { Section } from "@/components/PolicyLayout";

export default function TermsPage() {
  return (
    <PolicyLayout
      testId="terms-page"
      eyebrow="Legal"
      title="TERMS & CONDITIONS"
      subtitle="Please read these terms carefully before using the Jharkhand Pickleball Association (JPA) website."
      effective="1 February 2026"
    >
      <Section title="1. Acceptance of terms">
        <p>
          By accessing or using the JPA website (<b>www.jpaofficial.com</b>) — whether as a player, club, referee, coach or general visitor — you agree to be bound by these Terms &amp; Conditions and our Privacy Policy. If you do not agree, please discontinue use of the site.
        </p>
      </Section>

      <Section title="2. Eligibility & registration">
        <p>Player registration requires you to be at least 12 years of age (with parental consent if under 18). You confirm that all information provided during registration — including full name, date of birth, contact details, Aadhaar reference and photograph — is accurate and current.</p>
        <p>JPA reserves the right to verify all submissions and to approve, reject, suspend or revoke any account at its sole discretion.</p>
      </Section>

      <Section title="3. Player conduct & code of ethics">
        <p>All approved JPA players agree to abide by the AIPA code of ethics, fair-play standards and anti-doping rules while representing any JPA-sanctioned event. Misconduct, abusive behaviour, match-fixing or use of prohibited substances will result in immediate suspension and forfeiture of ranking points.</p>
      </Section>

      <Section title="4. Tournaments & entries">
        <p>Entries submitted through the site are subject to JPA and the organizing club&apos;s acceptance. Entry fees, once approved, are governed by our Refund &amp; Cancellation Policy. Any change in venue, schedule or format will be communicated through the website and/or WhatsApp.</p>
      </Section>

      <Section title="5. Intellectual property">
        <p>The JPA name, JPA logo, AIPA affiliation marks and all site content, code, imagery and rankings data are the property of JPA (or its licensors) and are protected under applicable copyright and trademark laws. You may not copy, modify or redistribute any content without written permission.</p>
      </Section>

      <Section title="6. User-uploaded content">
        <p>By uploading a photo, Aadhaar image, receipt, factsheet, club logo or any other file, you grant JPA a non-exclusive, royalty-free licence to store and display the content strictly for the purpose of running your JPA services. Sensitive documents (Aadhaar images) are visible only to JPA administrators for verification and are deleted immediately after approval when you opt-in to auto-deletion.</p>
      </Section>

      <Section title="7. Limitation of liability">
        <p>The website is provided on an &quot;as-is&quot; basis. JPA is not liable for any indirect, incidental or consequential damages arising from your use of the site, downtime, data loss, third-party services (payment gateways, WhatsApp, email providers) or on-court injuries during affiliated events.</p>
      </Section>

      <Section title="8. Governing law & jurisdiction">
        <p>These terms are governed by the laws of India. Any dispute arising out of these terms shall be subject to the exclusive jurisdiction of the courts at Ranchi, Jharkhand.</p>
      </Section>

      <Section title="9. Changes to these terms">
        <p>JPA may revise these terms at any time. Material changes will be highlighted on this page with an updated &quot;Effective&quot; date. Continued use of the site after such changes constitutes acceptance of the revised terms.</p>
      </Section>
    </PolicyLayout>
  );
}
